import FilterListingItemContentHeading from './FilterListingItemContentHeading';

export default FilterListingItemContentHeading;
